import React from 'react';
import { withStyles } from '@material-ui/core';
import RadioGroup, { RadioGroupProps } from '@material-ui/core/RadioGroup';
import ToggleButton, { ToggleButtonProps } from './ToggleButton';
import withThemeProvider from '../util/withThemeProvider';
import FormContainer, { FormContainerProps } from './FormContainer';

const styles = {
  buttonGroup: {
    marginLeft: '-4px',
    marginTop: '-4px',
    // this is to counter the button's border, which other form components don't have
  },
};

export const ToggleButtonGroupContext = React.createContext<{ disabled?: boolean }>({});

export type ToggleButtonGroupProps = {
  classes: any;
  children: React.ReactElement<ToggleButtonProps> | React.ReactElement<ToggleButtonProps>[];
} & RadioGroupProps &
  FormContainerProps;

const ToggleButtonGroup = withStyles(styles, { withTheme: true })(
  (props: ToggleButtonGroupProps) => {
    const { disabled, error, label, message, row = true, classes, ...rest } = props;
    return (
      <ToggleButtonGroupContext.Provider value={{ disabled }}>
        <FormContainer disabled={disabled} error={error} label={label} message={message}>
          <RadioGroup row={row} {...rest} className={classes.buttonGroup} />
        </FormContainer>
      </ToggleButtonGroupContext.Provider>
    );
  }
);

export { ToggleButton };
export default withThemeProvider(ToggleButtonGroup);

//to be used with ToggleButton children.
